import { createSelector } from 'reselect'

const getFetchSchoolDataRequest = state => state.SchoolData.fetchSchoolRequest
const getSchoolData = state => state.SchoolData.school

const getSchoolStatus = state => state.SchoolData.school.wonde.status

const isSchoolConnected = createSelector(
  [getSchoolStatus],
  status => status === 'connected'
)
const isSchoolPending = createSelector(
  [getSchoolStatus],
  status => status === 'pending'
)
const isSchoolNotConnected = createSelector(
  [getSchoolStatus],
  status => status === 'not_connected'
)
const isSchoolPulling = createSelector(
  [getSchoolStatus],
  status => status === 'pulling'
)
const isSchoolFinished = createSelector(
  [getSchoolStatus],
  status => status === 'finished'
)
const isSchoolInWonde = createSelector(
  [getSchoolStatus],
  status => status !== 'not_in_wonde_system'
)
const isSchoolUsingGroupCall = createSelector(
  [getSchoolData],
  school => school.groupcall && school.groupcall.on
)

const getConnectSchoolRequest = state => state.SchoolData.connectSchoolRequest
const getDisconnectSchoolRequest = state =>
  state.SchoolData.disconnectSchoolRequest
const getPullSchoolRequest = state => state.SchoolData.pullSchoolRequest

export {
  getFetchSchoolDataRequest,
  getSchoolData,
  isSchoolConnected,
  isSchoolPending,
  isSchoolNotConnected,
  isSchoolPulling,
  isSchoolFinished,
  isSchoolInWonde,
  getConnectSchoolRequest,
  getDisconnectSchoolRequest,
  getPullSchoolRequest,
  isSchoolUsingGroupCall
}
